(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("$rdf"), require("SolidLogic"));
	else if(typeof define === 'function' && define.amd)
		define(["$rdf", "SolidLogic"], factory);
	else if(typeof exports === 'object')
		exports["UI"] = factory(require("$rdf"), require("SolidLogic"));
	else
		root["UI"] = factory(root["$rdf"], root["SolidLogic"]);
})(this, (__WEBPACK_EXTERNAL_MODULE__264__, __WEBPACK_EXTERNAL_MODULE__663__) => {
return 